// react library imports
import { Wallet, Info, PlusCircle, CaretCircleLeft, ListBullets } from 'phosphor-react';
import Lottie from 'lottie-react';
import { motion } from 'framer-motion';
import { NavLink } from 'react-router-dom';
import {useDispatch} from 'react-redux';

// import assets and data
import upgrade from '../../Assets/Animation/upgrade.json';
import { footer } from './data';

// redux store imports
import { openLogOut, closeSidebar, openFund } from '../../Redux/sidebar/sidebar';


// Define the rotation variants
const rotateVariants = {
    open: { rotate: 180},
    closed: { rotate: 0 }
};

// subitem of sidebar
export const WalletCard=({preschoolInformation})=>{
	const dispatch = useDispatch()	
	return(
		<div className={`preschool_wallet_container mues_column_space_between side_bar_item
		mues_margin_bottom_16`}>
			<div className='mues_row_space_between'>
				<div className='mues_row_flex mues_grey_I'>
					<Wallet className='wrapper_icon' weight='fill'/>
					<p className={`mues_font_weight_500 
					mues_margin_left_4`}>Wallet</p>
				</div>
				<div className='mues_row_flex mues_column_gap_8 mues_blue'>
					<ListBullets className={`wallet_info_icon wrapper_icon`} weight='fill'/>
					<Info className={`wallet_info_icon wrapper_icon`} weight='fill'/>
				</div>
			</div>
			<h4 className={`mues_text_align_center mues_font_weight_600 mues_blue`}>
				{preschoolInformation?.mues_fund}
			</h4>
			<div className={`mues_row_center`}>
				<button className={`small_btn 
				mues_row_center btn mues_column_gap_4
				mues_blue_background mues_white`} onClick={()=>dispatch(openFund())}>
					<PlusCircle className='wrapper_icon mues_white' weight='fill'/>
					Add Funds
				</button>
			</div>
		</div>
	)
}

// subitem of sidebar
export const UpgradeToPro=()=>{
	const dispatch = useDispatch()	
	return(
		<div className={`preschool_pro_container mues_purple_background_gradient mues_column_space_between side_bar_item
		mues_pointer`}>
			<h6 className={`mues_font_weight_500 mues_white`}>Upgrade to PRO</h6>
			<div>
				<Lottie className='upgrade_to_pro_icon' animationData={upgrade} loop={true}/>
			</div>
			<NavLink to={'/dashboard/Pro'} onClick={()=>dispatch(closeSidebar())}>
			<button className={`mues_white_background small_btn
			mues_font_weight_500 mues_purple upgrade_pro_button btn`}>
				Upgrade Now
			</button>
			</NavLink>
		</div>
	)
}

// header of sidebar
export const Header=({preschoolInformation, active, setActive})=>{
	return(
		<header className={`preschool_logo_container side_bar_item mues_row_center`}>
			<img src={preschoolInformation?.preschool_logo} alt="preschool_logo"
			loading='lazy' />
			<motion.div className='side_responsive_icon mues_pointer'
			initial="closed" // Initial rotation state
			animate={active ? "open" : "closed"} // Toggle animation based on state
			variants={rotateVariants}
			onClick={()=>setActive(!active)}>
				<CaretCircleLeft className='side_bar_icon mues_blue' weight='fill'/>
			</motion.div>
		</header>
	)
}

// Footer of sidebar
export const Footer=()=>{
	const dispatch = useDispatch()
	return(
		<footer className='side_bar_footer mues_grey_II'>
			{footer.map(item=>(
				item.name==="Logout"? <div className={`mues_row_flex mues_column_gap_4
				mues_margin_bottom_8 mues_pointer`} key={item.id}
				onClick={()=>dispatch(openLogOut())}>
					{item.icon}
					<h6 className='mues_font_weight_500'>{item.name}</h6>
				</div>
				:<NavLink to={item.path} className={`mues_row_flex mues_column_gap_4
				mues_margin_bottom_8 mues_pointer`} key={item.id} onClick={()=>dispatch(closeSidebar())}>
					{item.icon}
					<h6 className='mues_font_weight_500'>{item.name}</h6>
				</NavLink>
			))}
		</footer>
	)
}